import LifehackModal from '@/apps/LifehackModal'
import React from 'react'

const LifehackBody = (): React.ReactElement => {
  return <LifehackModal />
}

export default LifehackBody
